import { render, staticRenderFns } from "./AdminNormatives.vue?vue&type=template&id=4f37d282&scoped=true"
import script from "./AdminNormatives.vue?vue&type=script&lang=js"
export * from "./AdminNormatives.vue?vue&type=script&lang=js"
import style0 from "./AdminNormatives.vue?vue&type=style&index=0&id=4f37d282&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f37d282",
  null
  
)

export default component.exports